import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { appointmentsAPI } from "@/lib/appointments-api";
import { ReportsUploadsCard } from "./reports/ReportsUploadsCard";
import { InvestigationNotesCard } from "./reports/InvestigationNotesCard";

interface ReportsHomeProps {
  onOpenDocument?: (doc: any) => void;
  isCompleted?: boolean;
}

export const ReportsHome = ({
  onOpenDocument,
  isCompleted = false,
}: ReportsHomeProps) => {
  const params = useParams<{ appointmentId: string }>();
  const appointmentId = params.appointmentId || "";

  const { data: appointmentDetails } = useQuery({
    queryKey: ["appointmentDetails", appointmentId],
    queryFn: () =>
      appointmentId
        ? appointmentsAPI.getAppointmentDetails(appointmentId)
        : null,
    enabled: !!appointmentId,
  });

  const patientId = appointmentDetails?.patient_id || "";

  return (
    <div className="h-full overflow-hidden grid grid-cols-2 gap-4 p-4">
      <ReportsUploadsCard
        patientId={patientId}
        onOpenDocument={onOpenDocument}
      />
      <InvestigationNotesCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
      />
    </div>
  );
};
